import { z } from "zod";

export const strategyEditorSearchSchema = z.object({
  returnPortfolioId: z
    .string()
    .regex(/^[a-zA-Z0-9_-]{1,128}$/)
    .optional()
    .catch(undefined),
});
